import { ReactNode } from 'react';
import { useInView } from '../../hooks/useInView';
import { SectionTitle } from './SectionTitle';

interface SectionWrapperProps {
    id: string;
    title?: string;
    children: ReactNode;
    alternate?: boolean;
}

export function SectionWrapper({ id, title, children, alternate = false }: SectionWrapperProps) {
    const [ref, isInView] = useInView(0.05);

    const bgClass = alternate
        ? 'bg-slate-50 dark:bg-slate-800/50'
        : 'bg-white dark:bg-slate-900';

    return (
        <section id={id} className={`py-16 md:py-24 ${bgClass}`}>
            <div
                ref={ref}
                className={`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
            >
                {title && <SectionTitle title={title} />}
                {children}
            </div>
        </section>
    );
}
